const TableRow = ({ data = [], widths = [], variant = "body" }) => {
    const variantClass = {
        header: "bg-light fw-bold border text-dark",
        accordion: "bg_sky text-primary border border-light",
        body: "bg-white text-dark border",
    }[ variant ];

    return (
        <div className={`d-flex text-center ${variantClass}`}>
            {data.map((cell, index) => (
                <div key={index} style={{ width: widths[ index ] || "120px" }} className="p-2 border-end">
                    {cell}
                </div>
            ))}
        </div>
    );
};

export default TableRow;
